cafm.recurrence = {

    startDateTime: null,
    updatedHandlerName: 'cafm.recurrence.recurrenceUpdated',

    registerUpdatedHandler: function(handler) {

        // regsiter the updated handler name
        cafm.handlers.set(this.updatedHandlerName, handler);
    },
    loadWeeklyForm: function (viewModel) {

        // bind the view model
		let currentForm = cafm.recurrence.getCurrentForm();
		currentForm.bindViewModel(viewModel);
        
        // get the tab
        var weeklyTab = $('.weeklyTabContent').prepareForm();

        // setup checkbox list
        var weekChkList = $('.patternDaysOfWeek .cfChkListUl');

        // set this on the checkbox list so it's enum aware
        weekChkList.attr('data-enum', true);

        // set default weekday selection
        cafm.forms.listSelector.setEnumValue(weekChkList, viewModel.DaysOfWeek);

        // prepare the range options
        cafm.recurrence.helpers.prepareRangeOptions(weeklyTab, viewModel);

        // setup weekday checkbox handler
        weeklyTab.find('.patternDaysOfWeek input.cfControl').change(cafm.recurrence.handlers.weekdayChecked);

        // append awkward bits of text
        weeklyTab.find('.patternInterval').append('<span class="intervalFieldSuffix cText">{0}</span>'.format(cafm.res.str.LabelWeeksOn));
        weeklyTab.find('.patternOccurrenceCount').append('<span class="intervalFieldSuffix cText">{0}</span>'.format(cafm.res.str.LabelOccurrences.toLocaleLowerCase()));

		currentForm.getViewModel().bind('change', cafm.recurrence.handlers.viewModelChanged);

    },
    loadMonthlyForm: function (viewModel) {

        var monthlyTab = $('.monthlyTabContent').prepareForm();

        // remove binding on labels as that will clear them
        monthlyTab.find('.patternDayOfMonthLabel,.patternMonthsLabel,.patternOfEveryLabel').find('.cfRoValSpan').removeAttr('data-bind');

		let currentForm = cafm.recurrence.getCurrentForm();
        // bind the view model
		currentForm.bindViewModel(viewModel);

        // prepare the range options
        cafm.recurrence.helpers.prepareRangeOptions(monthlyTab, viewModel);

        var pattern = monthlyTab.find('.patternOptionType ul').children();
        pattern.first()
            .append(monthlyTab.find('.patternDayOfMonth'))
            .append(monthlyTab.find('.patternDayOfMonthLabel'))
            .append(monthlyTab.find('.patternInterval:first'))
            .append(monthlyTab.find('.patternMonthsLabel:first'));

        pattern.last()
            .append(monthlyTab.find('.patternOfDayInMonth'))
            .append(monthlyTab.find('.patternDayOfWeek'))
            .append(monthlyTab.find('.patternOfEveryLabel'))
            .append(monthlyTab.find('.patternInterval:last'))
            .append(monthlyTab.find('.patternMonthsLabel:last'));

        // hookup the event and then filter to the default selection and select it
        monthlyTab.find('.patternOptionType input[type="radio"]').change(cafm.recurrence.handlers.patternOptionTypeChanged)
            .filter('[value="{0}"]'.format(viewModel.PatternOptionType)).trigger('change');

        monthlyTab.find('.patternOccurrenceCount').append('<span class="intervalFieldSuffix cText">{0}</span>'.format(cafm.res.str.LabelOccurrences.toLocaleLowerCase()));

		currentForm.getViewModel().bind('change', cafm.recurrence.handlers.viewModelChanged);
    },
    loadYearlyForm: function (viewModel) {

        var yearlyTab = $('.yearlyTabContent').prepareForm();

        // remove binding on labels as that will clear them
        yearlyTab.find('.patternOfEveryLabel').find('.cfRoValSpan').removeAttr('data-bind');

        // prepare the range options
        cafm.recurrence.helpers.prepareRangeOptions(yearlyTab, viewModel);
        
        var pattern = yearlyTab.find('.patternOptionType ul').children();
        pattern.first()
            .append(yearlyTab.find('.patternDayOfMonth'))
            .append(yearlyTab.find('.patternMonthOfYear:first'));

        pattern.last()
            .append(yearlyTab.find('.patternOfDayInMonth'))
            .append(yearlyTab.find('.patternDayOfWeek'))
            .append(yearlyTab.find('.patternOfEveryLabel'))
            .append(yearlyTab.find('.patternMonthOfYear:last'));
        
        // hookup the event and then filter to the default selection and select it
        yearlyTab.find('.patternOptionType input[type="radio"]').change(cafm.recurrence.handlers.patternOptionTypeChanged)
            .filter('[value="{0}"]'.format(viewModel.PatternOptionType)).trigger('change');

        // bind the view model

		let currentForm = cafm.recurrence.getCurrentForm();
		currentForm.bindViewModel(viewModel);

		yearlyTab.find('.patternOccurrenceCount').append('<span class="intervalFieldSuffix cText">{0}</span>'.format(cafm.res.str.LabelOccurrences.toLocaleLowerCase()));
		currentForm.getViewModel().bind('change', cafm.recurrence.handlers.viewModelChanged);
        
	},
	getCurrentForm()
	{
		let form = cafm.views.getActionForm();
		if (isNullOrUndefined(form) || form.length < 1)
		{
			form = cafm.views.getMainForm().find(".recurrenceForm");
		}
		return form;
	},
	getCurrentViewModel()
	{
		return cafm.recurrence.getCurrentForm().getViewModel();
	},
	handlers: {
		prepareForm: function (pattern, updatedHandler) {
			pattern = cafm.recurrence.helpers.prepareClientRecurrenceData(pattern);
			if (!isFunc(updatedHandler)) {
				console.log('No recurrence updated handler has been provided.');
				return;
			}
			else {
				cafm.recurrence.registerUpdatedHandler(updatedHandler);
			}
			cafm.recurrence.handlers.onPatternLoaded(pattern);
		},
        openForm: function (pattern, updatedHandler, onWindowClose) {
            pattern = cafm.recurrence.helpers.prepareClientRecurrenceData(pattern);

	        if (!isFunc(updatedHandler)) {

	            console.log('No recurrence updated handler has been provided.');
	            return;
	        }
	        else {
	            cafm.recurrence.registerUpdatedHandler(updatedHandler);
	        }

			cafm.views.openActionWindow({
				url: cafm.url.get('Recurrence/Configure'),
				method: 'GET',
				winOptions: {
					width: 800,
					height: 500,
					actions: {}
				},
				onLoad: function ()
				{
					cafm.recurrence.handlers.onPatternLoaded(pattern);
				},
				onWindowClose: onWindowClose
			});
		},
		onPatternLoaded: function (pattern) {
			var tabs = $('#recurrenceTabs');
			if (pattern) {
				tabs.data('postdata', pattern);
			}
			var dataKey = cafm.enums.getEnumKey(cafm.enums.RecurrencePatternFrequency, pattern && pattern.PatternFrequency ? pattern.PatternFrequency : cafm.enums.RecurrencePatternFrequency.Weekly);
			tabs.find('[data-key="{0}"]'.format(dataKey)).click();
		},
		patternOptionTypeChanged: function (args) {

		    var radio = $(args.currentTarget);
		    var val = radio.prop('value');
		    var tabCont = radio.parents('.recurrenceTabContent:first');
		    var pattern = tabCont.find('.patternOptionType > ul').children();
		    var every = pattern.first();
		    var onThe = pattern.last();
		    var controlsToDisable = [];
		    var controlsToEnable = [];


		    if (val == cafm.enums.SchedulePatternOptionType.Every) {

		        cafm.util.addAll(controlsToEnable, every.getNumericTextboxes());
		        cafm.util.addAll(controlsToEnable, every.getDropdowns());
		        cafm.util.addAll(controlsToDisable, onThe.getNumericTextboxes());
		        cafm.util.addAll(controlsToDisable, onThe.getDropdowns());
		    }
		    else {

		        cafm.util.addAll(controlsToDisable, every.getNumericTextboxes());
		        cafm.util.addAll(controlsToDisable, every.getDropdowns());
		        cafm.util.addAll(controlsToEnable, onThe.getNumericTextboxes());
		        cafm.util.addAll(controlsToEnable, onThe.getDropdowns());
		    }

		    for (var c in controlsToDisable){

		        var con = controlsToDisable[c];
		        if (isObj(con)) con.enable(false);
		    }

		    for (var c in controlsToEnable) {

		        var con = controlsToEnable[c];

		        if (isObj(con)) con.enable(true);
		    }
		},
	    patternRangeLimitChanged: function(args){
            
	        var radio = $(args.currentTarget);
	        var tabCont = radio.parents('.recurrenceTabContent:first');
	        var occCount = tabCont.find('#OccurrenceCount').data('kendoNumericTextBox');
	        var endBy = tabCont.find('#EndBy').data('kendoDatePicker');
	        var val = radio.prop('value');

	        if (val == cafm.enums.RecurrenceRangeLimit.LimitByNumberOfOccurrences) {

	            endBy.enable(false);
	            occCount.enable(true);
	        }
	        else {

	            occCount.enable(false);
	            endBy.enable(true);
	        }
	    },
	    viewModelChanged: function(args){

	        if (args.field == 'Description') {

	            return;
	        }

	        var refreshDescriptionFunc = function (viewModel) {

	            cafm.recurrence.helpers.getRecurrenceDescription({

	                recurrencePattern: viewModel,
	                callback: function (description) {
                        
	                    viewModel.set('Description', description);

	                    if (isFunc(viewModel.descriptionChangeHandler)) {

	                        viewModel.descriptionChangeHandler(description);
	                    }
	                }
	            });
	        }

	        if (isDefined(cafm.recurrence.refreshDescription)) {

	            clearTimeout(cafm.recurrence.refreshDescription);
	        }

	        cafm.recurrence.refreshDescription = setTimeout(function () {

	            var viewModel = args.sender;

	            if (isUndefined(viewModel.PatternFrequency)) {

	                viewModel = args.sender.source;
	            }

	            refreshDescriptionFunc(viewModel);
	        }, 500);
	    },
		weekdayChecked: function (args) {
            
		    var chk = $(args.currentTarget);
		    var checked = chk.prop('checked');
		    var v = chk.data('value');
		    var allChecks = $('.patternDaysOfWeek input.cfControl');
		    var allCheck = allChecks.filter('[data-value="{0}"]'.format(cafm.enums.RecurrencePatternDaysOfWeek.All));
		    var allWdCheck = allChecks.filter('[data-value="{0}"]'.format(cafm.enums.RecurrencePatternDaysOfWeek.AllWeekdays));
			var vTmp, valid, startDayOfWeek, viewModel = cafm.recurrence.getCurrentViewModel();
			


		    if(!checked) {

		        startDayOfWeek = cafm.recurrence.helpers.getDayOfWeekFromDate(viewModel.StartDateTime);
		    }

		    switch (v) {

		        case cafm.enums.RecurrencePatternDaysOfWeek.All:

		            // untick "All Weekdays"
		            allWdCheck.setChecked(false, true);

		            // loop all checkboxes to turn them on or off
		            allChecks.each(function (i, chkTmp) {

		                chkTmp = $(chkTmp);
		                vTmp = chkTmp.data('value');

		                // if "All" is unchecked then check the booking start day of week
		                if (!checked && vTmp == startDayOfWeek) {

		                    chkTmp.setChecked(true, true);
		                }
		                // check or uncheck it based on whether "All" is checked
		                else if (vTmp != cafm.enums.RecurrencePatternDaysOfWeek.All && vTmp != cafm.enums.RecurrencePatternDaysOfWeek.AllWeekdays) {

		                    chkTmp.setChecked(checked, true);
		                }
		            });

		            break;

		        case cafm.enums.RecurrencePatternDaysOfWeek.AllWeekdays:

                    // loop all checkboxes to turn them on or off
		            allChecks.each(function (i, chkTmp) {

		                chkTmp = $(chkTmp);
		                vTmp = chkTmp.data('value');

                        // is it a week day?
		                valid = vTmp != cafm.enums.RecurrencePatternDaysOfWeek.All &&
                                vTmp != cafm.enums.RecurrencePatternDaysOfWeek.AllWeekdays &&
                                vTmp != cafm.enums.RecurrencePatternDaysOfWeek.Saturday &&
                                vTmp != cafm.enums.RecurrencePatternDaysOfWeek.Sunday;

		                // if "All Weekdays" is unchecked then check the booking start day of week
		                if (!checked && vTmp == startDayOfWeek) {

		                    chkTmp.setChecked(true, true);
		                }
		                // if it's a weekday check or uncheck it based on whether "All Weekdays" is checked
		                else if (valid) {

		                    chkTmp.setChecked(checked, true);
		                }
                        // otherwise uncheck "All", and weekend days
		                else if (vTmp != cafm.enums.RecurrencePatternDaysOfWeek.AllWeekdays) {

		                    chkTmp.setChecked(false, true);
		                }
		            });
                    
		            break;

                // days of week
		        default:

		            // loop all checkboxes to get checked total to determine if "All" or "All Weekdays" should be ticked
		            vTmp = 0;
		            allChecks.each(function (i, chkTmp) {

		                chkTmp = $(chkTmp);

		                if (chkTmp.prop('checked')) {

		                    vTmp += chkTmp.data('value');
		                }
		            });

		            // tick or untick "All"
		            allCheck.setChecked(vTmp == cafm.enums.RecurrencePatternDaysOfWeek.All, true);

                    // tick or untick "All Weekdays"
		            allWdCheck.setChecked(vTmp == cafm.enums.RecurrencePatternDaysOfWeek.AllWeekdays, true);

                    // ensure not all weekday checkboxes are unticked
		            if (!cafm.forms.listSelector.getEnumValue($('.patternDaysOfWeek .cfChkListUl'))) {

		                chk.setChecked(true, true);
		            }

		            break;
		    }

            
		    // setup checkbox list
		    var weekChkList = $('.patternDaysOfWeek .cfChkListUl');
		    var viewModel = cafm.recurrence.getCurrentViewModel();
		    viewModel.set('DaysOfWeek', cafm.forms.listSelector.getEnumValue(weekChkList));
		},
		toolbar: {

		    ok: function () {

		        var recurrencePattern = cafm.views.getActionWindowViewModel();

		        if (recurrencePattern && isDefined(cafm.recurrence.refreshDescription)) {

		            setTimeout(cafm.recurrence.handlers.toolbar.ok, 2500);
		            cafm.views.getActionForm().showLoader();
		            return;
		        }
                
		        cafm.handlers.exe(cafm.recurrence.updatedHandlerName, recurrencePattern);

		        cafm.views.closeActionWindow();
		    },
		    cancel: function () {

		        cafm.toolbar.standardActionToolbar.cancel();
		    }
		}
	},
    helpers: {
        /**
         * Prepares pattern data we send to MVC controller. Includes a hack which removes ...Z part of DateTime so that UI culture in MVC controller does not apply Framework Time Zone to datetime instance
         * @param {any} pattern
         */
        prepareClientRecurrenceData: function (pattern) {

			let pattData = cafm.util.clone(pattern, true);
			pattData.StartDateTime = this.getDateInstance(pattData.StartDateTime);
            pattData.EndDateTime = this.getDateInstance(pattData.EndDateTime);

            pattData.StartDateTime = moment(pattData.StartDateTime).format('YYYY-MM-DDTHH:mm:ss');//Remove Zule identifier
            pattData.EndDateTime = moment(pattData.EndDateTime).format('YYYY-MM-DDTHH:mm:ss');
            return pattData;
		},
		getDateInstance: function (dateTime) {
			if (dateTime instanceof Date) {
				return dateTime;
			} else {
				return cafm.web.funcs.fromSessionToUTCDateTime(dateTime)
			}
		},
	    ensureMaxEndBy: function (pattern) {

	        var maxEndBy = cafm.recurrence.helpers.maxEndBy();

	        if (maxEndBy < pattern.EndBy) {

	            pattern.set('EndBy', maxEndBy);
	            return false;
	        }
	        else {

	            return true;
	        }
	    },
	    ensureMinEndBy: function(pattern) {

	        var minEndBy = cafm.recurrence.helpers.minEndBy();

	        if (minEndBy > pattern.EndBy) {

	            pattern.set('EndBy', minEndBy);
	            return false;
	        }
	        else {

	            return true;
	        }
	    },
	    ensureMinOccurrenceCount: function (pattern) {
            	        
	        if (pattern.OccurrenceCount < 1) {

	            pattern.set('OccurrenceCount', 1);
	            return false;
	        }
	        else {

	            return true;
	        }
	    },
	    getDayOfWeekFromDate: function(date) {
                  
	        var ret;
	        date = cafm.util.ensureDate(date);

	        if (isDate(date)) {

	            switch (date.getDay()) {
	                case 0: return cafm.enums.RecurrencePatternDaysOfWeek.Sunday;
	                case 1: return cafm.enums.RecurrencePatternDaysOfWeek.Monday;
	                case 2: return cafm.enums.RecurrencePatternDaysOfWeek.Tuesday;
	                case 3: return cafm.enums.RecurrencePatternDaysOfWeek.Wednesday;
	                case 4: return cafm.enums.RecurrencePatternDaysOfWeek.Thursday;
	                case 5: return cafm.enums.RecurrencePatternDaysOfWeek.Friday;
	                case 6: return cafm.enums.RecurrencePatternDaysOfWeek.Saturday;
	            }
	        }
	        else {
	            return cafm.enums.RecurrencePatternDaysOfWeek.None;
	        }
	    },
	    getRecurrenceDescription: function(args) {
            
            var pattern = cafm.recurrence.helpers.prepareClientRecurrenceData(args.recurrencePattern);

            if (pattern.RangeLimit == cafm.enums.RecurrenceRangeLimit.LimitByDate && !cafm.recurrence.helpers.ensureMinEndBy(pattern) || !cafm.recurrence.helpers.ensureMaxEndBy(pattern)) {

	            return;
	        }
            else if (pattern.RangeLimit == cafm.enums.RecurrenceRangeLimit.LimitByNumberOfOccurrences && !cafm.recurrence.helpers.ensureMinOccurrenceCount(pattern)) {

	            return;
	        }

	        cafm.actions.execute({

	            url: cafm.url.api('Recurrence/GetRecurrenceDescription'),
                values: pattern,
	            suppressErrors: true, // TODO: Validate client-side instead of hiding errors - not enough time to implement full validation
	            statusCodeFuncs: {

	                200: args.callback
	            },
	            complete: function () {

	                delete cafm.recurrence.refreshDescription;
	            }
	        });
	    },
	    isSingleDayOfWeek: function(daysOfWeek) {

	        var dow = cafm.enums.RecurrencePatternDaysOfWeek, 
                daysOfWeekEnums = [dow.Sunday, dow.Monday, dow.Tuesday, dow.Wednesday, dow.Thursday, dow.Friday, dow.Saturday];

	        return cafm.enums.isSingleEnumValue(daysOfWeek, daysOfWeekEnums);
	    },
	    maxEndBy: function(){

			var startDate = cafm.views.getMainFormViewModel().StartDateTime;
			if (startDate == null) {
				startDate = new Date();
			}
			var maxEndBy = new Date(startDate);
	        cafm.util.truncateToDate(maxEndBy);
	        maxEndBy.setFullYear(maxEndBy.getFullYear() + 5);
	        return maxEndBy;
	    },
	    minEndBy: function () {
			var startDate = cafm.views.getMainFormViewModel().StartDateTime;
			if (startDate == null)
			{
				startDate = new Date();
			}
			var minEndBy = new Date(startDate);
	        cafm.util.truncateToDate(minEndBy);
	        minEndBy.setDate(minEndBy.getDate() + 1);
	        return minEndBy;
	    },
	    prepareRangeOptions: function (tabContent, viewModel) {

	        var limit = tabContent.find('.patternRangeLimit ul').children();
	        var limitCount = tabContent.find('.patternOccurrenceCount');
	        var limitDate = tabContent.find('.patternEndBy');
	        limit.first().append(limitCount);
	        limit.last().append(limitDate);

	        // hookup the event and then filter to the default selection and select it
	        tabContent.find('.patternRangeLimit input[type="radio"]').change(cafm.recurrence.handlers.patternRangeLimitChanged)
                .filter('[value="{0}"]'.format(viewModel.RangeLimit)).trigger('change');

            //set date picker min date
	        var dp = tabContent.find('#EndBy').data('kendoDatePicker');

	        // set date picker min value
	        dp.min(cafm.recurrence.helpers.minEndBy());

	        // set date picker max value
	        dp.max(cafm.recurrence.helpers.maxEndBy());
	    }
	}
}